import { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";

const fade = (d = 0) => ({
  initial: { opacity: 0, y: 24 }, whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" }, transition: { duration: 0.55, delay: d },
});

export function FaqSection({ titleKey = "lp.faq.title", overlineKey = "lp.faq.overline", items = [] }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(0);
  if (!items?.length) return null;
  return (
    <section id="faq" className="mx-auto max-w-3xl px-5 py-20" data-testid="faq-section">
      <motion.div {...fade()} className="text-center">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-dark">{t(overlineKey)}</div>
        <h2 className="mt-3 font-heading text-3xl font-extrabold text-navy sm:text-4xl">{t(titleKey)}</h2>
      </motion.div>
      <div className="mt-10 space-y-3">
        {items.map((it, i) => (
          <motion.div key={i} {...fade(i * 0.04)} className="card-soft overflow-hidden">
            <button
              onClick={() => setOpen(open === i ? -1 : i)}
              data-testid={`faq-q-${i}`}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
            >
              <span className="font-heading text-base font-bold text-navy">{it.q}</span>
              <ChevronRight className={`h-5 w-5 shrink-0 text-cyan-dark transition-transform ${open === i ? "rotate-90" : ""}`} />
            </button>
            {open === i && (
              <div className="px-5 pb-5 text-sm leading-relaxed text-slate-600" data-testid={`faq-a-${i}`}>{it.a}</div>
            )}
          </motion.div>
        ))}
      </div>
    </section>
  );
}
